<template>
	<div class="header">
		<div style="display: flex; align-items: center">
			<img
				class="logo"
				src="../../assets/images/summary/top-logo.png"
				alt=""
			/>
		</div>
		<div style="display: flex">
			<!-- <div v-for="(item, index) in routerList" :key="index" class="menu_item cursor-pointer" :class="path == item.path || path.includes(item.path)
                ? 'menu_item_active'
                : ''
                " @mouseover="onRouterMouseover(item)" @mouseout="onRouterMouseout" @click="routerMenu(item)">
                {{ item.name }}
            </div> -->
			<a
				v-for="(item, index) in routerList"
				:key="index"
				class="menu_item cursor-pointer"
				:class="
					path == item.path || path.includes(item.path)
						? 'menu_item_active'
						: ''
				"
				:href="item.url"
				@mouseover="onRouterMouseover(item)"
				@mouseout="onRouterMouseout"
				@click="routerMenu(item)"
			>
				{{ item.name }}
			</a>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			routerList: [
				{
					path: "/index",
					name: "首页",
					url: "#",
					key: 1,
					hasChildren: false,
				},
				{
					path: "/merchant",
					name: "服务项目",
					url: "#project",
					key: 1,
					hasChildren: false,
				},
				{
					path: "/about",
					name: "御悦到家",
					url: "#yuyue",
					key: 5,
					hasChildren: false,
				},
				{
					path: "/about",
					name: "关于我们",
					url: "#about",

					key: 5,
					hasChildren: false,
				},
				{
					path: "/about",
					name: "联系我们",
					url: "#contract",
					key: 5,
					hasChildren: false,
				},
				// {
				//     path: "/index",
				//     name: "首页",
				//     key: 1,
				//     hasChildren: false
				// },
				// {
				//     path: "/merchant",
				//     name: "商家合作",
				//     key: 1,
				//     hasChildren: false
				// },
				// {
				//     path: "/about",
				//     name: "关于我们",
				//     key: 5,
				//     hasChildren: false
				// }
			],
			secondMenuShow: false,
			secondMenu: [],

			company: {},
		};
	},
	computed: {
		path() {
			return this.$route.path;
		},
	},
	mounted() {},
	methods: {
		onRouterMouseover(item) {
			console.log(item, this.secondMenuShow);
			if (item == "second") {
				this.secondMenuShow = true;
			}
			if (item.hasChildren) {
				this.secondMenu = item.children;
				this.secondMenuShow = true;
			}
			console.log(item, this.secondMenuShow);
		},
		onRouterMouseout() {
			this.secondMenuShow = false;
		},
		routerMenu(item) {
			if (item.hasChildren) {
				this.secondMenu = item.children;
				return;
			}
			// this.$router.push({ path: item.path });
		},
		routerSecondMenu(path) {
			// this.$router.push({ path });
		},
	},
};
</script>
<style scoped>
.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-bottom: 1px solid #ccc;
	position: relative;
	padding: 0 2.25vw;
	/* padding: 0 8.25vw; */
}

.logo {
	width: auto;
	height: 40px;
	display: block;
}

.header .menu_item {
	padding: 0 40px;
	height: 80px;
	display: flex;
	align-items: center;
	color: rgba(0, 0, 0, 0.9);
	cursor: pointer;
}

.header .menu_item_active {
	color: #00913a;
	position: relative;
}

.header .menu_item_active::before {
	content: "";
	width: 48px;
	height: 3px;
	background: #00913a;
	position: absolute;
	left: 50%;
	transform: translateX(-50%);
	top: 0;
}

.header_second {
	width: 100%;
	background: #fff;
	position: absolute;
	top: 80px;
	z-index: 20;
	border-top: 1px solid #ccc;
}

.header_second_menu {
	width: 1200px;
	display: flex;
	flex-wrap: wrap;
	margin: 0 auto;
	padding-top: 30px;
}

.second_menu_item {
	display: flex;
	align-items: center;
	margin: 0 80px 30px 0;
}

.second_menu_item:hover {
	color: #00913a;
}

.second_menu_item:nth-child(7) {
	margin-right: 0;
}

.menu_item .cursor-pointer:hover {
	color: #00913a;
}

.second_menu_icon {
	color: rgba(0, 0, 0, 0.9);
	margin-left: 4px;
}
</style>
